/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Vacation { 
    title?: string;
    from: string;
    to: string;
    startTime?: string;
    endTime?: string;
    message?: string;
    recurrence?: string;
}

